import React from 'react';

const NotFound = () => {
    return(
        <div className="not-found">
            Kick your robot! Page not found!
        </div>
    );
}

export default NotFound;


// WEBPACK FOOTER //
// ./src/pages/NotFound.jsx